import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  query,
  where,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase';
import { WorksheetTemplate } from '../../types/worksheet';

const COLLECTION = 'worksheetTemplates';

export const worksheetTemplateService = {
  async getAll(organizationId: string): Promise<WorksheetTemplate[]> {
    const q = query(
      collection(db, COLLECTION),
      where('organizationId', '==', organizationId),
      where('isActive', '==', true),
      orderBy('createdAt', 'desc')
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(d => ({
      id: d.id,
      ...d.data(),
      createdAt: d.data().createdAt?.toDate() || new Date(),
      updatedAt: d.data().updatedAt?.toDate() || new Date(),
    })) as WorksheetTemplate[];
  },

  async create(data: Omit<WorksheetTemplate, 'id' | 'createdAt' | 'updatedAt'>): Promise<string> {
    const docRef = await addDoc(collection(db, COLLECTION), {
      ...data,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    return docRef.id;
  },

  async update(id: string, data: Partial<WorksheetTemplate>): Promise<void> {
    await updateDoc(doc(db, COLLECTION, id), {
      ...data,
      updatedAt: serverTimestamp(),
    });
  },

  async delete(id: string): Promise<void> {
    await deleteDoc(doc(db, COLLECTION, id));
  },

  async deactivate(id: string): Promise<void> {
    await updateDoc(doc(db, COLLECTION, id), {
      isActive: false,
      updatedAt: serverTimestamp(),
    });
  },
};
